import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderCancellationPolicyHistoryFilterEntity } from '../../domain/entities/OrderCancellationPolicyHistoryFilterEntity'

export class OrderCancellationPolicyHistoryFilterModel extends OrderCancellationPolicyHistoryFilterEntity {
  constructor(dataDto: OrderCancellationPolicyHistoryFilterEntity) {
    super()
    mapEntityProperties<OrderCancellationPolicyHistoryFilterEntity>(this, dataDto, {
      map: {
        fromDate: formatDateTime(dataDto.fromDate),
        toDate: formatDateTime(dataDto.toDate)
      }
    })
  }
}

function formatDateTime(value?: Date | string | null) {
  if (!value) return undefined
  return new Date(value).toISOString()
}
